import { Link } from 'react-router-dom';
import { FEATURES } from '../../data/features';

interface RelatedFeaturesProps {
  slugs: string[];
}

export function RelatedFeatures({ slugs }: RelatedFeaturesProps): JSX.Element {
  const related = slugs
    .map((slug) => FEATURES.find((f) => f.slug === slug))
    .filter(Boolean);

  if (related.length === 0) return <></>;

  return (
    <section className="py-[var(--landing-section-py)] bg-[var(--landing-surface-alt)]">
      <div className="max-w-[var(--landing-container-max)] mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-2xl font-bold text-[var(--landing-text-primary)] mb-8 text-center">
          Related features
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {related.map((feature) => (
            <Link
              key={feature!.slug}
              to={`/features/${feature!.slug}`}
              className="bg-[var(--landing-surface)] rounded-[var(--landing-radius)] p-6 border border-[var(--landing-border)] hover:border-[var(--landing-accent)] transition-colors group block"
            >
              <h3 className="text-lg font-semibold text-[var(--landing-text-primary)] group-hover:text-[var(--landing-accent-text)] transition-colors mb-2">
                {feature!.title}
              </h3>
              <p className="text-sm text-[var(--landing-text-muted)] leading-relaxed">
                {feature!.subtitle}
              </p>
              <span className="inline-block mt-3 text-sm text-[var(--landing-accent-text)] font-medium">
                Learn more &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
